import { ReactNode, useEffect, useState } from 'react';

import { Box, Button, Result } from '@aicon-dev/caas-ui';
import { useTranslation } from 'react-i18next';

import { Sheet } from '~/components/ui/Sheet';
import { useNavigate } from '~/router';

import { container } from './styles.css';

export interface ErrorDisplayProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  resetButtonText?: ReactNode;
  cancelButtonText?: ReactNode;
  onReset?: () => void;
  onCancel?: () => void;
}

export const ErrorDisplay = (props: ErrorDisplayProps) => {
  const { t } = useTranslation('error_page');
  const {
    icon,
    title,
    description,
    resetButtonText = t('error_page:retry'),
    cancelButtonText = t('error_page:logout'),
    onReset,
    onCancel,
  } = props;
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <Sheet visible={visible} onClose={() => navigate(-1)}>
      <Box className={container}>
        {/* <Header /> */}

        <Result
          status="error"
          icon={icon}
          title={title}
          subTitle={description}
          style={{
            paddingLeft: 16,
            paddingRight: 16,
            justifyContent: 'center',
            flex: 1,
          }}
        />

        <Box display="flex" flexDirection="column" gap="12" p="16">
          <Button color="primary" variant="filled" size="large" block onClick={onReset}>
            {resetButtonText}
          </Button>

          {!!onCancel && (
            <Button size="large" block onClick={onCancel}>
              {cancelButtonText}
            </Button>
          )}
        </Box>
      </Box>
    </Sheet>
  );
};
